import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../Card/Card'
import Button from '../CustomButtons/Button'
import { primaryColor } from '../../assets/jss/material-kit-pro-react'
import Close from '@material-ui/icons/Close'

const Popup = ({ hidePopup }) => (
  <SignUpCard color="white">
    <Button
      className="close-button"
      onClick={hidePopup}
      simple
      justIcon
      color="primary"
    >
      <Close />
    </Button>
    <p>
      Buy & Sell Cryptocurrency on Canada’s most advanced and comprehensive
      crypto exchange network
    </p>
    <Button href="https://exchange.bitnational.com/?register=true" round color="info">
      <span style={{ color: primaryColor }}>SIGN UP</span>
    </Button>
  </SignUpCard>
)

const SignUpCard = styled(Card)`
  &&& {
    transition: opacity 300ms ease;
    transition-delay: 300ms;
    position: fixed;
    /* @supports (position: sticky) {
      margin-left: auto;
      margin-right: ${p => p.theme.col()};
      position: sticky;
    } */
    z-index: 9999;
    padding: 2rem;
    padding-top: 2.5rem;
    max-width: 300px;

    bottom: ${p => p.theme.col(0.5)};
    right: ${p => p.theme.col()};

    .close-button {
      position: absolute;
      right: 0.25rem;
      top: 0.05rem;
    }

    @media screen and (max-width: 1000px) {
      padding: 1.5rem;
      bottom: 0;
      left: 0;
      width: 100vw;
      max-width: unset;
      position: fixed;
      margin: 0;
    }
  }
`

export default Popup



// WEBPACK FOOTER //
// ./src/components/Popup/index.jsx